// Polyfill Buffer for Solana libraries (must be first!)
import { Buffer } from 'buffer';
window.Buffer = Buffer;

import { initSentry } from '@/shared/config/sentry';
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@features/auth";
import { InitializationProvider, ThemeProvider } from "@/shared/providers";
import App from "./app/App.tsx";
import "./shared/styles/index.css";

// Load AI diagnostics in development (exposes window.testAI())
if (import.meta.env.DEV) {
  import("@shared/utils/aiDiagnostics");
}

initSentry();

// Auto-reload when a lazy-loaded chunk fails to fetch (post-deploy hash mismatch)
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <InitializationProvider>
            <App />
          </InitializationProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
